import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import {
  RecipientBankAccountListEntity,
  RecipientBankAccountService,
} from 'services/openapi';

import { RecipientBankAccountQueryKeys } from '../constants';

export const useGetAccountBanksQuery = () => {
  const queryKey = [RecipientBankAccountQueryKeys.GET_OWN_LIST];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<RecipientBankAccountListEntity, Error>({
    queryKey,
    queryFn: () =>
      RecipientBankAccountService.recipientBankAccountControllerGetOwnList(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...QUERY_CACHE_CONFIG.UNTIL_INVALIDATED,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
